var sliders = document.querySelectorAll('.items_scroll');
var isDown = false;
var startX;
var scrollLeft;

sliders.forEach(slider => {
  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
    enableLinks(); // Re-enable links on mouse leave
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
    enableLinks(); // Re-enable links on mouse up
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1; // scroll-fast
    slider.scrollLeft = scrollLeft - walk;
    disableLinks(); // Disable links when scrolling horizontally
  });
});

function disableLinks() {
  var links = document.querySelectorAll('.items_scroll a');
  links.forEach(link => {
    link.style.pointerEvents = 'none'; // Disable link clicks
  });
}

function enableLinks() {
  var links = document.querySelectorAll('.items_scroll a');
  links.forEach(link => {
    link.style.pointerEvents = 'auto'; // Re-enable link clicks
  });
}